import React from 'react';
import ListItem from '../DataTransferObjects/ListItem';

interface DropDownListProps {
  label: string;
  className: string;
  value: string;
  name: string;
  mandatory: boolean;
  changeState: (value: string) => void;
  data: ListItem[];
  hasDefaultOption?: boolean;
}
const DropDownList: React.FC<DropDownListProps> = (props) => {
  return (
    <div className={props.className}>
      <label>
        {props.label} {props.mandatory && <span className="mandatory">*</span>}{' '}
      </label>
      <select
        className="input-form"
        value={props.value}
        name={props.name}
        onChange={(e) => props.changeState(e.target.value)}
      >
        {props.hasDefaultOption && <option value="0">(SELECIONE)</option>}
        {props.data.map((item) => (
          <option value={item.value} key={item.value}>
            {item.text}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDownList;
